import React, { useContext, useState, useEffect } from 'react';
import { PrimeraPagina } from './PrimeraPagina';
import { SegundaPagina } from './SegundaPagina';
import { TerceraPagina } from './TerceraPagina';

import { FichaContext } from '../../context/FichaContext';
import { valida } from './PrimeraPagina';
import { validaNum } from './PrimeraPagina';
import { validaCorreo } from './PrimeraPagina';
import { validaIdentidad } from './PrimeraPagina';
import { validaCelular } from './PrimeraPagina';
import Convocatoria from '../Convocatoria/Index';
import Swal from 'sweetalert2';
import '../Datos_Generales/Generales.css';
import { block, unblock } from '../../helpers/loading';
import { axiosPublic, axiosPdf } from '../../helpers/axios';
import Footer from '../Footer/footer';
var moment = require('moment');

export const FichaScreen = () => {
	const [pagina, setPagina] = useState(0);
	const { data } = useContext(FichaContext);
	const [arreglo, setArreglo] = useState(0);
	const { primera } = data;
	const { segunda } = data;
	const { tercera } = data;
	const { convocatoria } = data;
	const { idconvocatoria } = convocatoria;
	const valfecha = moment().subtract(15, 'y');
	const valfechamin = moment().subtract(70, 'y');
	//Datos de las 1ra, 2da y 3er página
	const {
		Pnombre,
		Snombre,
		Papellido,
		Sapellido,
		identidad,
		correo,
		fechanaci,
		edad,
		tcasa,
		tcelular,
		sexo,
		trabaja,
		nacionalidad,
		ecivil,
		limitacion,
		AGraduacion,
		etnia,
		otraLimita,
		confcorreo,
	} = primera;

	const { razones, jornada, radiopc, radiointernet, radioestudio, radiotitulo, radiomatriculado } = segunda;

	const { sistema, sede, carrera1, carrera2, carrera3 } = tercera;

	const nombres = Pnombre.trim() + ' ' + Snombre.trim();
	const apellidos = Papellido.trim() + ' ' + Sapellido.trim();

	const datos = {
		identidad,
		idconvocatoria,
		nombres,
		apellidos,
		sexo,
		ecivil,
		etnia,
		nacionalidad,
		limitacion,
		correo,
		tcasa,
		tcelular,
		trabaja,
		edad,
		fechanaci,
		otraLimita,
		AGraduacion,
		razones,
		jornada,
		radiopc,
		radiointernet,
		radioestudio,
		radiotitulo,
		radiomatriculado,
		sistema,
		sede,
		carrera1,
		carrera2,
		carrera3,
	};
	//Elemntos de objeto 'datos' con alias
	const {
		idconvocatoria: id_convocatoria,
		sexo: id_sexo,
		ecivil: id_estado_civil,
		etnia: id_grupo_etnico,
		nacionalidad: id_pais,
		limitacion: id_limitacion_fisica,
		tcasa: telefono_casa,
		tcelular: telefono_movil,
		fechanaci: fecha_nacimiento,
		otraLimita: otra_limitacion,
		AGraduacion: anio_graduacion,
		razones: id_razon_ingreso,
		jornada: id_jornada_estudio,
		radiopc: acceso_pc,
		radiointernet: acceso_internet,
		radioestudio: tiempo_estudio,
		radiotitulo: uni_titulopasado,
		radiomatriculado: uni_presente,
		sistema: id_centro,
		sede: id_sede,
		carrera1: id_carrera_estudiar,
		carrera2: id_carrera_estudiar2,
		carrera3: id_carrera_estudiar3,
	} = datos;

	useEffect(() => {
		if (convocatoria.pagina === 1) setPagina(1);
	}, [convocatoria.pagina]);

	const handleAnteriorClick = (e) => {
		if (pagina > 1) setPagina(pagina - 1);
	};

	const handleSiguienteClick = async (e) => {
		let estado = false;
		var objprim = Object.values(primera);
		var objseg = Object.values(segunda);
		const msg = 'Debe llenar todos los campos con el formato solicitado.';
		objprim.length = 14;

		if (
			(valida(Pnombre)[1] ||
				(valida(Snombre)[1] && Snombre !== '') ||
				valida(Papellido)[1] ||
				(valida(Sapellido)[1] && Sapellido !== '')) &&
			!estado
		) {
			Swal.fire('', 'Nombres y apellidos deben tener mínimo 3 caracteres y no llevar números.', 'warning');
			estado = true;
		}

		if (sexo === '' && !estado) {
			Swal.fire('', 'Campo "Sexo" es obligatorio.', 'warning');
			estado = true;
		}

		if (sexo === '' && !estado) {
			Swal.fire('', 'Campo "Sexo" es obligatorio.', 'warning');
			estado = true;
		}

		if (trabaja === '' && !estado) {
			Swal.fire('', 'Campo "Trabaja" es obligatorio.', 'warning');
			estado = true;
		}

		objprim.forEach((objprim) => {
			if (objprim === '' && !estado) {
				Swal.fire('', msg, 'warning');
				estado = true;
			}
		});

		if (AGraduacion === '' && !estado) {
			Swal.fire('', 'Campo "Año de graduación" es obligatorio.', 'warning');
			estado = true;
		}

		if (
			(fechanaci > valfecha ||
				fechanaci < valfechamin ||
				validaCorreo(correo)[1] ||
				confcorreo !== correo ||
				validaCelular(telefono_movil)[1]) &&
			!estado
		) {
			Swal.fire('', msg, 'warning');
			estado = true;
		}

		if (
			((nacionalidad === '99' && validaNum(identidad)[1]) ||
				validaNum(edad)[1] ||
				validaNum(tcelular)[1] ||
				edad.length > 2 ||
				edad.length < 2 ||
				tcelular.length > 11 ||
				tcelular.length < 8 ||
				(nacionalidad === '99' && validaIdentidad(identidad)[1]) ||
				edad < 15) &&
			!estado
		) {
			Swal.fire('', msg, 'warning');
			estado = true;
		}

		const { data } = await axiosPublic('validaRegistro', {
			identidad: identidad,
			id_convocatoria: id_convocatoria,
		});

		if (data['success'] && !estado) {
			Swal.fire('Error', data['msg'], 'error');
			estado = true;
		}

		if (pagina === 2) {
			objseg.forEach((objseg) => {
				if (objseg === '' && !estado) {
					Swal.fire('', msg, 'warning');
					estado = true;
				}
			});
		}

		if (pagina === 3) {
			if ((sistema === '' || sede === '' || carrera1 === '') && !estado) {
				Swal.fire('', msg, 'warning');
				estado = true;
			}

			if (
				(carrera3 === carrera1 || carrera2 === carrera1 || carrera3 === carrera2 || carrera1 === carrera3) &&
				carrera1 !== '' &&
				carrera2 !== '' &&
				!estado
			) {
				Swal.fire('', 'Debe selecionar diferentes carreras.', 'warning');
				estado = true;
			}

			if (((arreglo === 2 && carrera2 === '') || (arreglo >= 3 && carrera3 === '')) && !estado) {
				Swal.fire('', 'Debe seleccionar otra opción de carrera.', 'warning');
				estado = true;
			}
		}

		//Fin validaciones.

		if (pagina < 3 && !estado) {
			setPagina(pagina + 1);
		} else if (pagina === 3 && !estado) {
			const dataSheet = {
				identidad,
				id_convocatoria,
				nombres,
				apellidos,
				id_sexo,
				id_estado_civil,
				id_grupo_etnico,
				id_pais,
				id_limitacion_fisica,
				correo,
				telefono_casa,
				telefono_movil,
				trabaja,
				edad,
				fecha_nacimiento,
				anio_graduacion,
				otra_limitacion,
				id_razon_ingreso,
				id_jornada_estudio,
				acceso_pc,
				acceso_internet,
				tiempo_estudio,
				uni_titulopasado,
				uni_presente,
				id_centro,
				id_sede,
				id_carrera_estudiar,
				id_carrera_estudiar2,
				id_carrera_estudiar3,
			};
			//POST FICHA
			try {
				block();
				const resp = await axiosPublic('ficha', dataSheet, 'POST');
				const data = await resp.data;

				if (data['success']) {
					const getPdf = async () => {
						const resp = await axiosPdf('getPdf', { id_convocatoria, identidad });
						const pdf = new File([resp.data], 'Comprobante.pdf', { type: 'application/pdf' });
						window.open(URL.createObjectURL(pdf), '_blank');
					};
					getPdf();
					unblock();

					Swal.fire({
						title: 'Inscripción Enviada',
						text: data['msg'],
						icon: 'success',
						backdrop: true,
						allowOutsideClick: false,
						didClose: () => {
							window.location.reload();
						},
					});
				}
			} catch (error) {
				console.info(error);
				const data = error.response.data;
				Swal.fire('Error', data['msg'], 'error');
			}
		}
	};

	if (pagina === 0) {
		return <Convocatoria />;
	} else {
		return (
			<div className="contenido">
				<div className="Body">
					<div className="container">
						{(pagina === 1 && <PrimeraPagina />) ||
							(pagina === 2 && <SegundaPagina />) ||
							(pagina === 3 && <TerceraPagina setArreglo={setArreglo} />)}
						<div className="container2">
							<div className="btn-group">
								<button className="btn btn-outline-primary" onClick={handleAnteriorClick}>
									Anterior
								</button>
								<button className="sigue btn btn-outline-primary" onClick={handleSiguienteClick}>
									{pagina === 3 ? 'Enviar' : 'Siguiente'}
								</button>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		);
	}
};
